import { Grid } from '@chakra-ui/react'
import { useTranslationsContext } from 'BrokerTsLib/src/context/TranslationsContext'
import type { Statistics } from 'BrokerTsLib/src/dtos'
import { StatCard } from './StatCard'
import { StatValue } from './StatValue'

interface CountStatsGridProps {
  stats: Statistics
  isLoadingStats: boolean
}

export const CountStatsGrid = ({ stats, isLoadingStats }: CountStatsGridProps) => {
  const { translate } = useTranslationsContext()

  return (
    <Grid
      sx={{
        justifyContent: 'space-between',
        gap: 4,
        gridColumn: { xl: '1/3' },
        flexFlow: 'wrap',
        gridTemplateColumns: { base: 'repeat(4, auto)', xl: 'repeat(6, auto) 0' },
      }}
    >
      <StatCard label={translate('ui.Dashboard.Stats.ContractsCount', 'Počet smluv')}>
        <StatValue fontSize='xl' isLoading={isLoadingStats}>
          {stats.pocetSmluv}
        </StatValue>
      </StatCard>

      <StatCard label={translate('ui.Dashboard.Stats.OffersCount', 'Počet nabídek')}>
        <StatValue fontSize='xl' isLoading={isLoadingStats}>
          {stats.pocetVytvorenych}
        </StatValue>
      </StatCard>

      <StatCard label={translate('ui.Dashboard.Stats.ClientsCount', 'Počet klientů')}>
        <StatValue fontSize='xl' isLoading={isLoadingStats}>
          {stats.pocetKlientu}
        </StatValue>
      </StatCard>
      {/* 
      <StatCard label={<>Doplňková<br /> pojištění</>}>
        <StatValue fontSize='xl' isLoading={isLoadingStats}>
          {stats.pocetDoplnku}
        </StatValue>
      </StatCard> */}
    </Grid>
  )
}
